/**
 * Crea la disposición del tragamonedas
 * @param {*} scene
 */
export function crearCartelesTematica(scene) {
  // NO SACAR
  scene.cartelTematica = scene.add.image(375, 92, 'cartelTematica1');
  scene.cartelTematica.setDepth(400);

  //Animación del cartel temático
  /*
  scene.anims.create({
    key: "cartelTematicaMovimiento",
    frames: scene.anims.generateFrameNumbers("cartelTematica1Animado", {
      start: 0,
      end: 27,
    }),
    frameRate: 10,
    repeat: -1,
  });
  */

  //scene.cartelTematica = scene.add.sprite(375, 92, "cartelTematicaMovimiento").setVisible(true);
  //scene.cartelTematica.setDepth(400);
  //scene.cartelTematica.anims.play("cartelTematicaMovimiento");
}
